/**
 * Creates a SmartReader support ticket in the TTAI helpdesk, bypassing the
 * packaged @ttai/chat-bubble widget — its sealed form has no channel for
 * deploymentKey/deviceSerial. Calls the TTAI dashboard's public ticket
 * endpoint directly (already accepts both fields, see ttai-platform #148).
 */
export async function createSupportTicket({
  apiBaseUrl,
  helpDeskId,
  title,
  description,
  contactEmail,
  deploymentKey,
  deviceSerial,
}) {
  const body = { title, description, channel: 'WEB' };
  if (contactEmail) body.contactEmail = contactEmail;
  if (deploymentKey) body.deploymentKey = deploymentKey;
  if (deviceSerial) body.deviceSerial = deviceSerial;

  const response = await fetch(`${apiBaseUrl}/api/helpdesk/${helpDeskId}/tickets`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error('Unable to create support ticket');
  }

  return response.json();
}
